import { browserStorageGetItem, browserStorageSetItem } from '@/utils/browserStorage.ts';

export const NEW_BADGES = {
  COLLAB_FILTER: { key: 'dashboardsOwnedFilterCollaboratorsUsed' },
  COLLAB_BREAKDOWN: { key: 'dashboardsBreakdownCollaboratorsUsed' },
};

export function useNewBadgeDismissal() {
  function isBadgeDismissed(key: string | undefined): boolean {
    if (!key) return true;
    return browserStorageGetItem(key) === 'true';
  }

  function dismissBadge(key: string): void {
    browserStorageSetItem(key, 'true');
  }

  return { isBadgeDismissed, dismissBadge };
}
